<template>
  <v-alert
    v-if="show"
    :type="alertType"
    dense
    outlined
    class="dev-api-wiring-hint mb-3"
  >
    <div class="dev-api-wiring-title font-weight-medium mb-1">
      Data sources (this browser build)
    </div>
    <ul class="dev-api-wiring-list mb-0 pl-4">
      <li>
        <strong>NekoHR API (timesheets, projects, roster):</strong>
        <code>{{ nekoApi }}</code>
      </li>
      <li v-if="timerV1">
        <strong>Timer v1 (active session / roster):</strong>
        <code>{{ timerV1 }}</code>
        <span v-if="timerV1Local" class="dev-api-wiring-warn">
          — local empty DB is normal; use production URL below for real active
          timers.
        </span>
      </li>
      <li v-else><strong>Timer v1:</strong> off (legacy timer rows only).</li>
    </ul>
    <p v-if="timerV1Local" class="caption mb-0 mt-2">
      To match production: in <code>.env</code> set
      <code
        >VUE_APP_TIMER_V1_API_BASE_URL=https://nekohr.nekoapi.xyz/timer-v1/</code
      >
      or comment it out, then restart <code>npm run serve</code>.
    </p>
  </v-alert>
</template>

<script>
import {
  isLocalTimerV1Configured,
  resolvedNekoApiBaseUrl,
  resolvedTimerV1BaseUrl,
} from "@/services/axios.config";

export default {
  name: "DevApiWiringHint",
  props: {
    /** When true, always show (e.g. Koneko after empty fetch). */
    force: {type: Boolean, default: false},
  },
  computed: {
    timerV1Local() {
      return isLocalTimerV1Configured();
    },
    show() {
      return this.force || this.timerV1Local;
    },
    alertType() {
      return this.timerV1Local ? "warning" : "info";
    },
    nekoApi() {
      return resolvedNekoApiBaseUrl || "(unknown)";
    },
    timerV1() {
      return resolvedTimerV1BaseUrl() || "(disabled)";
    },
  },
};
</script>

<style scoped>
.dev-api-wiring-list {
  font-size: 0.8rem;
  line-height: 1.45;
}
.dev-api-wiring-warn {
  color: #e65100;
}
</style>
